<template >
    <div style="height:64px; display:flex; align-items:center">
        <v-btn text class="button" style="height:40px; width:160px" :to="`${link}`">
            <v-img :src="require('../assets/long_button_on.png')"  contain height="40px" width="160px">
                <div class="btn_center">
                    <v-img style="height:20px; max-width:20px" contain :src="require('../assets/' + icon)"></v-img>
                    <span :style="`color:${color}; font-size:18px;`">{{text}}</span>
                    <v-img style="height:20px; max-width:20px" contain :src="require('../assets/' + icon)"></v-img>
                </div>
            </v-img>
        </v-btn>
    </div>                
</template>
<script>
import {
  VImg,
  VBtn,
} from "vuetify/lib";
export default {
  components: {    
    VImg,
    VBtn,
  },
    props:{
        text:String,
        color:String,
        link:String,
        icon:String,
    },
}
</script>
<style>
.btn_center{
    display:flex;
    justify-content: center;
    height:40px;
    align-items: center;
}
</style>